// Google Analytics configuration and utilities
import { GA_MEASUREMENT_ID, ENABLE_ANALYTICS } from '@/config/analytics';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

export const initializeGA = () => {
  if (!ENABLE_ANALYTICS || !GA_MEASUREMENT_ID || GA_MEASUREMENT_ID.startsWith('G-XXXXXXXXXX')) {
    console.log('Google Analytics not configured or disabled');
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(...args: any[]) {
    window.dataLayer.push(args);
  };

  // Configure Google Analytics
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_title: document.title,
    page_location: window.location.href,
  });
};

// Track page views
export const trackPageView = (path: string, title?: string) => {
  if (window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title || document.title,
    });
  }
};

// Track custom events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track ecommerce events
export const trackPurchase = (transactionId: string, items: any[], value: number, currency: string = 'EUR') => {
  if (window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: currency,
      items: items,
    });
  }
};

export const trackAddToCart = (itemId: string, itemName: string, price: number, currency: string = 'EUR') => {
  if (window.gtag) {
    window.gtag('event', 'add_to_cart', {
      currency: currency,
      value: price,
      items: [{
        item_id: itemId,
        item_name: itemName,
        price: price,
        quantity: 1,
      }],
    });
  }
};